export default __webpack_public_path__ + "static/media/landing_section_img_4.d1820ebf.png";